import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import panelApi from "@/lib/panelApi";
import { useFetch } from "@/hooks/useFetch";

const TIER_KEYS = ["bronze_min", "prata_min", "ouro_min", "platina_min", "diamante_min", "mestre_min"];

export const useBaseConfigs = () => useQuery({
  queryKey: ["panel-base-configs"],
  queryFn: async () => (await panelApi.get("/panel/base-configs")).data?.configs || {},
});

export const minsForWith = (list, configs) => (uid, mins) => {
  const c = (list || []).find((x) => x.id === uid);
  const bid = (c?.base_ids || []).find((b) => configs?.[b]);
  if (!bid) return mins;
  const out = { ...mins };
  TIER_KEYS.forEach((k) => { if (configs[bid][k] != null) out[k] = configs[bid][k]; });
  return out;
};

// Níveis por entregas de cada colaborador conforme a base dele (cai nos globais se a base não tiver config).
export const useMinsFor = () => {
  const { data: configs } = useBaseConfigs();
  const collabs = useFetch("/admin/collaborators");
  const list = collabs.data?.collaborators;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(minsForWith(list, configs), [list, configs]);
};
